/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

type DropdownComponentParameters = {
  title : string,
  id : string,
  options : Array<string>,
  onSelectHandler : (value: string, key: string) => void,
  selectedOption : string,
};

export function DropdownComponent({
  title,
  id,
  options,
  onSelectHandler,
  selectedOption,
} : DropdownComponentParameters) {
  return (
    <>
      <p style={{ marginBottom: '6px', fontWeight: '600', display: 'block' }}>
        {title}
      </p>

      {/* This div is to force a re-render when the selectedOption changes.
          React will not always updated the component if that option changes */}

      <div key={selectedOption}>
        <select
          onChange={(e) => onSelectHandler(e.target.value, id)}
          defaultValue={selectedOption}
        >
          <option value={' '} />
          {options.map((opt, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <option key={index} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
